const colorToClassMap = {
  'inline-link': 'c-button--inline-link',
  link: 'c-button--link',
  none: 'c-button--none',
  notify: 'c-button--notify',
  primary: 'c-button--primary',
  secondary: 'c-button--secondary',
  'secondary-link': 'c-button--secondary-link',
  subtle: 'c-button--subtle',
  'secondary-turquoise': 'c-button--secondary-turquoise',
  'secondary-link-turquoise': 'c-button--secondary-link-turquoise',
  tertiary: 'c-button--tertiary',
  'tertiary-link': 'c-button--tertiary-link',
};

const sizeToClassMap = {
  small: 'c-button--small',
  large: 'c-button--large',
};

export const BUTTON_COLORS = Object.keys(colorToClassMap);
export const BUTTON_SIZES = Object.keys(sizeToClassMap);
export const BUTTON_CLASS_MAP = {
  color: colorToClassMap,
  size: sizeToClassMap,
};

export const iconPositionClassMap = {
  left: 'c-button__icon--left',
  right: 'c-button__icon--right',
  top: 'c-button__icon--top',
};
